<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>设备维保</el-breadcrumb-item>
    </el-breadcrumb>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;" ref="questionTable">
      <el-table-column prop="memo" label="设备信息" show-overflow-tooltip></el-table-column>
      <el-table-column prop="nickname" label="客户名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="phone" label="客户电话" show-overflow-tooltip></el-table-column>
      <el-table-column prop="imei" label="机油剩余时间" show-overflow-tooltip></el-table-column>
    </el-table>
  </div>
</template>

<script>
import {remainOil} from "../../api/userMG";

export default {
  data() {
    return {
      loading: false, //是显示加载
      listData: [], //用户数据
      remain: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 1
      }
    }
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    refresh() {
      this.getdata()
    },
    getdata() {
      this.loading = true
      remainOil().then(res => {
        if (res.code == 200) {
          this.listData = res.result.repair
          this.remain = res.result.remain
          this.loading = false
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/home/repair.vue